export default __webpack_public_path__ + "static/media/1655.97d84dc1.png";